<template>
  <transition
    @beforeEnter="beforeEnter"
    @enter="enter"
    @beforeLeave="beforeLeave"
    @leave="leave"
    :css="false">
    <slot />
  </transition>
</template>

<script>
  import anime from 'animejs';

  export default {
    components: {},
    props:      {
      duration: {
        type:     Number,
        required: false,
        default:  250,
      },
    },
    data() {
      return {};
    },

    computed:   {},

    methods:    {

      beforeEnter(el) {
        el.style.height = '0';
        el.style.overflow = 'hidden';
      },

      enter(el, done) {
        const height = el.getClientRects().length > 0 ? el.getClientRects().item(0).height : 0;

        anime(
          {
            targets:  el,
            height:   {
              value:    `${el.scrollHeight - height + 32}px`,
              duration: this.duration,
            },
            round:    1,
            easing:   'easeOutExpo',
            complete: done,
          },
        );
      },

      beforeLeave(el) {
        el.style.overflow = 'hidden';
      },

      leave(el, done) {
        anime(
          {
            targets:       el,
            height:        {
              value:    `0`,
              duration: this.duration,
            },
            paddingTop:    {
              value:    0,
              duration: this.duration,
            },
            paddingBottom: {
              value:    0,
              duration: this.duration,
            },
            marginTop:     {
              value:    0,
              duration: this.duration,
            },
            marginBottom:  {
              value:    0,
              duration: this.duration,
            },
            round:         1,
            easing:        'easeOutExpo',
            complete:      done,
          },
        );
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/CollapseAnimation.vue